import { Injectable, computed, signal } from '@angular/core';
import { Facility } from '#models';

@Injectable({ providedIn: 'root' })
export class WorkflowHeaderFacilityFilterService {
  private _facilities = signal<Facility[]>([]);
  private _selectedFacilityId = signal<string | null>(null);

  facilities = this._facilities.asReadonly();
  selectedFacilityId = this._selectedFacilityId.asReadonly();
  selectedFacility = computed(() => {
    const id = this._selectedFacilityId();
    if (!id) {
      return null;
    }
    return this._facilities().find(facility => facility.id === id) ?? null;
  });

  setFacilities(facilities: Facility[]): void {
    this._facilities.set(facilities);
  }

  setSelectedFacilityId(facilityId: string | null): void {
    this._selectedFacilityId.set(facilityId);
  }
}